import React from 'react';
import useOnlineStatus from '../../hooks/useOnlineStatus';

const OfflineBanner = () => {
  const { isOnline } = useOnlineStatus();

  if (isOnline) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-gray-800 text-white text-center py-2 px-4 text-sm font-medium">
      You&apos;re offline. Showing cached data.
    </div>
  );
};

export default OfflineBanner;
